import { Link, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { If, Else } from "lib/@components/switch"

export function LegislationLibraryChooseFolderCrumb({ item, last, onNavigate }) {
    return (
        <Stack direction="row" alignItems="center" spacing={0.5} component="span">
            <Iconify icon="mdi:chevron-right" width={16} height={16} sx={{ color: "text.disabled" }} />
            <If value={last}>
                <Typography color="text.primary" variant="body2">
                    {item.name}
                </Typography>
                <Else>
                    <Link
                        component="button"
                        type="button"
                        onClick={handleClick}
                        underline="hover"
                        color="inherit"
                        variant="body2"
                    >
                        {item.name}
                    </Link>
                </Else>
            </If>
        </Stack>
    )

    function handleClick() {
        onNavigate(item.id)
    }
}
